// extracted by mini-css-extract-plugin
export var activeDot = "_5l-c";
export var buttonContainer = "_5l-9";
export var channelButton = "_5l-a";
export var clickable = "_5l-d";
export var content = "_5l-0";
export var contentFull = "_5l-2";
export var contentThird = "_5l-1";
export var contentWrapper = "_5l-7";
export var description = "_5l-5";
export var heightShort = "_5l-f";
export var image = "_5l-3";
export var imageContainer = "_5l-4";
export var selectButton = "_5l-e";
export var spinnerContainer = "_5l-b";
export var titleContent = "_5l-8";
export var titleWrapper = "_5l-6";